import makeStyles from '@mui/styles/makeStyles';
const APP_BAR_HEIGHT = 40;
export const useStyles = makeStyles((theme) => ({
  activeFilterBadge: {
    marginTop: theme.spacing(1),
  },
  actionsMenu: {
    paddingBottom: theme.spacing(1.25),
    paddingTop: theme.spacing(1.25),
  },
  innerWrapper: {
    padding: theme.spacing(2.5, 0),
  },
  wrapper: {
    maxWidth: `calc(1200px + ${theme.spacing(9)})`,
    margin: '0 auto',
    paddingTop: `calc(${theme.spacing(5)} + ${APP_BAR_HEIGHT}px)`,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(4),
  },
  wrapperCenter: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    left: '50%',
    position: 'absolute',
    textAlign: 'center',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  wrapperFeedback: {
    alignItems: 'center',
    display: 'flex',
    left: '50%',
    position: 'absolute',
    textAlign: 'center',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  wrapperTopList: {
    alignItems: 'center',
    borderBottom: `solid 1px ${theme.palette.grey[200]}`,
    display: 'flex',
    width: '100%',
    position: 'sticky',
    top: `calc(${APP_BAR_HEIGHT}px + 20px)`,
    backgroundColor: theme.palette.background.default,
    zIndex: 1000,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(4),
    maxWidth: `calc(1200px + ${theme.spacing(9)})`,
    margin: '0 auto',
  },
  categoriesList: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    maxWidth: `calc(1200px + ${theme.spacing(9)})`,
    margin: '0 auto',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(4),
    marginTop: theme.spacing(8), // 64px space below the sticky header
  },
  categoryItem: {
    marginBottom: theme.spacing(1),
  },
  loadMoreTrigger: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    minHeight: '60px',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  noResults: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    minHeight: '200px',
  },
}));
